
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"37"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#E5A60E","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M43.474 35.067H3.828a2.139 2.139 0 01-2.137-2.136v-8.547a2.14 2.14 0 012.137-2.137h39.638a2.14 2.14 0 012.136 2.137v7.66l.01.887a2.139 2.139 0 01-2.138 2.136zM5.607 13.075h11.799a.885.885 0 00.883-.883.885.885 0 00-.883-.883H6.278L7.58 7.87a.876.876 0 00.257.04h7.17a.885.885 0 00.883-.884.885.885 0 00-.883-.882h-6.77l1.199-3.188.039-.067a2.242 2.242 0 011.937-1.104h24.394c.801 0 1.524.414 1.933 1.107l.041.07 6.758 17.874H2.68l2.927-7.76zm41.36 9.423c-.01-.018-7.658-20.25-7.686-20.296a3.92 3.92 0 00-3.485-2.11H11.412a3.92 3.92 0 00-3.485 2.11A9691.31 9691.31 0 00.242 22.498 4.019 4.019 0 000 23.836v8.959a3.938 3.938 0 003.93 3.93h39.338a3.938 3.938 0 003.93-3.93v-8.959c.01-.474-.074-.92-.232-1.338z"}}),_c('path',{attrs:{"d":"M26.704 29.198H6.556a.885.885 0 01-.882-.882c0-.486.397-.883.882-.883h20.148c.485 0 .882.397.882.883a.885.885 0 01-.882.882m7.248 0h-3.327a.885.885 0 01-.883-.882c0-.486.398-.883.883-.883h3.327c.486 0 .883.397.883.883a.885.885 0 01-.883.882m6.691 0h-3.327a.885.885 0 01-.883-.882c0-.486.398-.883.883-.883h3.327c.486 0 .883.397.883.883a.885.885 0 01-.883.882"}})])])
          )
        }
      }
    